import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LiveResultsService, OrganiserService} from "@services";
import {LANDING_ROUTE} from "../app-routing.module";
import {EventItem, Organiser} from "@model";

export const LiveEventsResolver: ResolveFn<Observable<EventItem[]> |
  Promise<EventItem> | EventItem[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   liveResultsService: LiveResultsService = inject(LiveResultsService)): Observable<EventItem[]> => {
    return liveResultsService.fetchLiveEvents();
  }
